import { render } from "./Solicitar.vue?vue&type=template&id=222e8ae6"
import script from "./Solicitar.vue?vue&type=script&lang=js"
export * from "./Solicitar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__